import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BrandLogo } from "@/components/common/BrandLogo";

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-6 text-center" data-testid="not-found-page">
      <BrandLogo size="lg" />
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent"><Compass className="h-6 w-6 text-primary" aria-hidden="true" /></div>
      <div>
        <h1 className="font-heading text-2xl font-semibold">{t("common.notFound")}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t("common.notFoundHint")}</p>
      </div>
      <Button asChild data-testid="not-found-home"><Link to="/app">{t("common.goHome")}</Link></Button>
    </div>
  );
}
